module.exports = __webpack_public_path__ + "img/gartek-services-fire-protection-solutions.5d99536d.png";